<script lang="ts">
	import Nav from './components/Nav.svelte';
	import Footer from './components/Footer.svelte';

	export let name: string;
</script>

<div id={name}>
	<Nav />
	<section id="hero">
		<div class="container u-text-align_center">
			<div class="embed">
				<iframe width="560" height="315" src="https://www.youtube.com/embed/800eeWT-3Ow?controls=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
			</div>
			<h1>Become Legend!</h1>
			<p><strong>BarFight</strong> is a playable Sandbox game in the Metaverse.<br />You'll need to download the Sandbox Game Maker first.</p>
			<a class="btn" href="https://www.sandbox.game/en/experiences/BarFight/723b41c6-e862-4ccf-ac3f-285db0debc88/page/" target="_blank" rel="noreferrer">Play BarFight!</a>
		</div>
	</section>

	<!-- STORY -->
	<a name="story">
		<section id="story">
			<div class="container u-text-align_center">
				<h2>Story</h2>
			</div>
			<div class="container">
				<ul class="list">
					<li>Adventure / Mini RPG game type</li>
					<li>On Sandbox, land size 1x1</li>
					<li>The town of ()`s Pide “Ekows Pub” has been locked. The towns folk are lost and an ominous feel has fallen over the town.</li>
					<li>Talk around town about creatures living beneath the pub, hiding in the shadows around town.</li>
					<li>Become Local Legend</li>
					<li>Talk shit</li>
					<li>Fight</li>
					<li>Find the Keys, gather the gear, and Defeat Bagootz to rid the town of evil.</li>
				</ul>
			</div>
		</section>
	</a>

	<!-- ROADMAP -->
	<a name="roadmap">
		<section id="roadmap">
			<div class="container u-text-align_center">
				<h2>Roadmap</h2>
			</div>
			<div class="container">
				<ul class="list">
					<li>Build Lounge above the bar </li>
					<li>Acquire bigger land and build to the story and game</li>
				</ul>
			</div>
		</section>
	</a>

	<!-- CHARACTERS -->
	<a name="characters">
		<section id="characters">
			<div class="container u-text-align_center">
				<h2 class="u-margin-bottom_small">Characters</h2>
				<div class="character-wrapper">
					<div class="character">
						<img src="/assets/img/character-jimmy.png" alt="Jimmy" />
						<h3>Jimmy</h3>
						<p>Town's beloved barfly.</p>
					</div>
					<div class="character">
						<img src="/assets/img/character-antone.png" alt="Antone" />
						<h3>Antone</h3>
						<p>Town scrapper, builder of mighty weapons.</p>
					</div>
					<div class="character">
						<img src="/assets/img/character-ralph.png" alt="Ralph" />
						<h3>Ralph</h3>
						<p>Bar manager.</p>
					</div>
					<div class="character">
						<img src="/assets/img/character-jeff.png" alt="Jeff" />
						<h3>Jeff</h3>
						<p>Bartender, takes no shit.</p>
					</div>
					<div class="character">
						<img src="/assets/img/character-tom.png" alt="Tom" />
						<h3>Tom</h3>
						<p>Local collector of shiny things.</p>
					</div>
					<div class="character">
						<img src="/assets/img/character-jenn.png" alt="Jenn" />
						<h3>Jenn</h3>
						<p>Town's last warrior in the fight against evil. Engineer.</p>
					</div>
					<div class="character">
						<img src="/assets/img/character-savage.png" alt="Randy Savage" />
						<h3>Randy Savage</h3>
						<p>Pawn shop owner.</p>
					</div>
					<div class="character">
						<img src="/assets/img/character-bagootz.png" alt="Bagootz" />
						<h3>Bagootz</h3>
						<p>The Demon Lord.</p>
					</div>
				</div>
			</div>
		</section>
	</a>

	<Footer />
</div>

<style type="text/scss">
	#hero {
		padding: 1rem 0 8rem 0;
	}

	#story, #characters {
		background-color: var(--color-light);
		color: var(--color-dark);
	}

	#story,
	#roadmap {
		.story-highlights {
			font-size: 1.25rem;
		}
	}

	.character-wrapper {
		display: flex;
		justify-content: space-around;
		align-items: center;
		flex-wrap: wrap;
		margin-bottom: 2rem;

		.character {
			align-self: flex-start;
			display: flex;
			flex-direction: column;
			margin-bottom: 1rem;
			width: 30%;

			img {
				width: 100%;
				height: auto;
			}
		}
	}
</style>